import BindingContext from "@odata/BindingContext";

export const AdditionalSubmissionPath = BindingContext.localContext("AdditionalSubmission");
export const AdditionalSubmissionDateCorrectionDiscoveredPath = "##DateCorrectionDiscovered##";
export const AdditionalSubmissionCorrectionReasonPath = "##CorrectionReason##";
export const AdditionalSubmissionReferenceNumberOfNoticePath = "##ReferenceNumberOfNotice##";

export const REFERENCE_NUMBER_PLACEHOLDER = "xxxxxxxx/xx/xxxx-xxxxx-xxxxxx";